(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header') || this.parentElement || this;
      if (!this.header) return;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (this.closest('.header-wrapper--wings')) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        if (entries[0]) this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header || !this.headerBounds) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.closest('.header-wrapper--wings')) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Wings: mega menu open on hover + backdrop (tylko pod nagłówkiem) */
  function initWingsMegaMenuHover() {
    var header = document.querySelector('.header--wings');
    if (!header || !header.querySelector('.mega-menu')) return;
    var backdrop = document.getElementById('MegaMenuBackdrop');
    var headerWrapper = document.querySelector('.header-wrapper');
    function updateBackdrop() {
      var open = header.querySelector('details.mega-menu[open]');
      if (backdrop) {
        if (open) {
          if (headerWrapper) {
            var rect = headerWrapper.getBoundingClientRect();
            backdrop.style.setProperty('--mega-backdrop-top', rect.bottom + 'px');
          }
          backdrop.classList.add('is-visible');
        } else {
          backdrop.classList.remove('is-visible');
        }
      }
      if (open) document.body.classList.add('mega-menu-open');
      else document.body.classList.remove('mega-menu-open');
    }
    header.querySelectorAll('details.mega-menu').forEach(function(details) {
      details.addEventListener('toggle', updateBackdrop);
    });
    var menuGroups = header.querySelectorAll('.header__menu-item-group');
    var closeTimer = null;
    header.querySelectorAll('summary.header__menu-item-summary[data-url]').forEach(function(summary) {
      summary.addEventListener('click', function(e) {
        e.preventDefault();
        var url = summary.getAttribute('data-url');
        if (url) window.location.href = url;
      });
    });

    menuGroups.forEach(function(group) {
      var details = group.querySelector('details.mega-menu');
      if (!details) return;
      group.addEventListener('mouseenter', function() {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = null;
        header.querySelectorAll('details.mega-menu[open]').forEach(function(d) {
          if (d !== details) {
            d.removeAttribute('open');
            var s = d.querySelector('summary');
            if (s) s.setAttribute('aria-expanded', 'false');
          }
        });
        details.setAttribute('open', '');
        var sum = details.querySelector('summary');
        if (sum) sum.setAttribute('aria-expanded', 'true');
        updateBackdrop();
      });
      group.addEventListener('mouseleave', function(e) {
        var related = e.relatedTarget;
        if (related && group.contains(related)) return;
        closeTimer = setTimeout(function() {
          details.removeAttribute('open');
          var sum = details.querySelector('summary');
          if (sum) sum.setAttribute('aria-expanded', 'false');
          closeTimer = null;
          updateBackdrop();
        }, 200);
      });
    });
  }
  function runWingsHover() {
    initWingsMegaMenuHover();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWingsHover);
  } else {
    runWingsHover();
  }
  window.addEventListener('load', function() {
    setTimeout(runWingsHover, 0);
  });

  } catch(e) { console.error(e); }
})();
})();
